import { Routes } from '@angular/router';
import { MainPageComponent } from './containers/main-page/main-page.component';
import { ObtainTokenPageComponent } from './containers/obtain-token-page/obtain-token-page.component';
import { EServicesPageComponent } from './containers/e-services-page/e-services-page.component';
import { PaymentsPageComponent } from './containers/payments-page/payments-page.component';
import { NotFoundComponent } from './containers/not-found/not-found.component';
import { LogoutComponent } from './containers/logout/logout.component';
import {
  ApplicationInfoPageComponent
} from './containers/applications/application-info-page/application-info-page.component';
import { ApplicationInfoResolver } from './resolvers/application-Info.resolver';
import { SubpagePageComponent } from './containers/subpage-page/subpage-page.component';
import { SubpageResolver } from './resolvers/subpage.resolver';
import { SavedListPageComponent } from './containers/applications/saved-list-page/saved-list-page.component';
import { ApprovedListPageComponent } from './containers/applications/approved-list-page/approved-list-page.component';
import {
  ApprovedPreviewPageComponent
} from './containers/applications/approved-preview-page/approved-preview-page.component';
import { SentListPageComponent } from './containers/applications/sent-list-page/sent-list-page.component';
import { SentPreviewPageComponent } from './containers/applications/sent-preview-page/sent-preview-page.component';
import { LoginGovPageComponent } from './containers/login-gov-page/login-gov-page.component';
import { GotoLoginGovPageComponent } from './containers/goto-login-gov-page/goto-login-gov-page.component';
import { PaymentsStatusPageComponent } from './containers/payments-status-page/payments-status-page.component';
import { MyDetailsPageComponent } from './containers/my-details-page/my-details-page.component';
import { AuthGuard } from './guards/auth.guard';
import { IsCompletedUserDataGuard } from './guards/is-completed-user-data.guard';
import {
  ApplicationAttachmentsPaymentPageComponent
} from './containers/applications/application-attachments-payment-page/application-attachments-payment-page.component';
import {
  applicationCreatePageRoutes
} from './containers/applications/application/create-page/application-create-page.routes';
import {
  applicationEditPageRoutes
} from './containers/applications/application/edit-page/application-edit-page.routes';
import { myCasesRoutes } from './containers/my-cases/my-cases.routes';
import { surveysRoutes } from './containers/surveys/surveys.routes';
import { LoginComponent } from './containers/login/login.component';
import { MunicipalWastePageComponent } from './containers/municipal-waste-page/municipal-waste-page.component';
import {
  MunicipalWasteHarmonogramPageComponent
} from './containers/municipal-waste-page/containers/municipal-waste-harmonogram-page/municipal-waste-harmonogram-page.component';
import {
  EApplicationCreatePageComponent
} from './containers/e-application/e-application-create-page/e-application-create-page.component';
import {
  EApplicationPreviewPageComponent
} from './containers/e-application/e-application-preview-page/e-application-preview-page.component';
import { civicBudgetRoutes } from './containers/civic-budget-page/civic-budget.routes';
import { HowToUsePageComponent } from './containers/how-to-use-page/how-to-use-page.component';
import { myBillsRoutes } from './containers/my-bills-page/my-bills.routes';
import { PrivacyStatementPageComponent } from './containers/privacy-statement-page/privacy-statement-page.component';
import { MySettingsPageComponent } from './containers/my-settings-page/my-settings-page.component';

export const routes: Routes = [
  { component: ObtainTokenPageComponent, path: 'obtain_token', pathMatch: 'full' },
  { component: LoginGovPageComponent, path: 'login-gov', pathMatch: 'full' },
  { component: GotoLoginGovPageComponent, path: 'goto-login-gov', pathMatch: 'full' },
  { component: LogoutComponent, path: 'logout', pathMatch: 'full' },
  { component: LoginComponent, path: 'login', pathMatch: 'full' },
  { component: MyDetailsPageComponent, path: 'moje-dane', pathMatch: 'full' },
  {
    component: MySettingsPageComponent,
    path: 'ustawienia',
    pathMatch: 'full',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  { component: MainPageComponent, path: 'strona-glowna', pathMatch: 'full' },
  ...myCasesRoutes,
  ...surveysRoutes,
  ...civicBudgetRoutes,
  {
    component: EApplicationCreatePageComponent,
    path: 'zgloszenie/skladanie-wniosku',
    pathMatch: 'full'
  },
  {
    component: EApplicationPreviewPageComponent,
    path: 'zgloszenie/sukces',
    pathMatch: 'full'
  },
  {
    component: EServicesPageComponent,
    path: 'e-uslugi', pathMatch: 'full'
  },
  {
    component: ApplicationInfoPageComponent,
    path: 'e-uslugi/:contentUrl',
    resolve: {
      applicationInfo: ApplicationInfoResolver
    }
  },
  ...applicationCreatePageRoutes,
  {
    component: SavedListPageComponent,
    path: 'wnioski-robocze',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  ...applicationEditPageRoutes,
  {
    component: ApprovedListPageComponent,
    path: 'wnioski-zatwierdzone',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: ApprovedPreviewPageComponent,
    path: 'wnioski-zatwierdzone/:contentUrl/:appId',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: ApprovedPreviewPageComponent,
    path: 'wnioski-zatwierdzone/:contentUrl/:appId/:signStatus',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: SentListPageComponent,
    path: 'wnioski-wyslane',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: SentPreviewPageComponent,
    path: 'wnioski-wyslane/:contentUrl/:appId',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  ...myBillsRoutes,
  {
    component: ApplicationAttachmentsPaymentPageComponent,
    path: 'zaplac-online/zalaczniki/:appId',
    pathMatch: 'full',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: PaymentsPageComponent,
    path: 'platnosci-online',
    pathMatch: 'full'
  },
  {
    component: PaymentsStatusPageComponent,
    path: 'platnosci-online/:payment_token',
    pathMatch: 'full'
  },
  {
    component: PaymentsStatusPageComponent,
    path: 'platnosci-online/:payment_token/:appId/:serviceType',
    pathMatch: 'full'
  },
  {
    component: MunicipalWastePageComponent,
    path: 'odpady-komunalne',
    pathMatch: 'full'
  },
  {
    component: MunicipalWasteHarmonogramPageComponent,
    path: 'odpady-komunalne/:areaId',
    pathMatch: 'full'
  },
  {
    component: HowToUsePageComponent,
    path: 'jak-korzystac',
    pathMatch: 'full'
  },
  {
    component: PrivacyStatementPageComponent,
    path: 'info/polityka-prywatnosci',
    pathMatch: 'full'
  },
  {
    component: SubpagePageComponent,
    path: 'info/:subpageUrl',
    pathMatch: 'full',
    resolve: {
      subpage: SubpageResolver
    }
  },
  { path: '', redirectTo: 'strona-glowna', pathMatch: 'full' },
  { component: NotFoundComponent, path: 'not-found', pathMatch: 'full' },
  { path: '**', redirectTo: 'not-found' }
];
